module.exports = __webpack_public_path__ + "img/16.29b9f2e2.jpg";